import { render, staticRenderFns } from "./InternalTransferView.vue?vue&type=template&id=f24984fc"
import script from "./InternalTransferView.vue?vue&type=script&lang=js"
export * from "./InternalTransferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports